module.exports = __webpack_public_path__ + "static/img/productimg6.db559b63.png";